import { Link } from "react-router-dom";
import { Icon, familyMeta } from "../components/Icons.jsx";
import Seo from "../components/Seo.jsx";
import { beginnerDays } from "./_routes-data.js";
export { beginnerDays };

export default function BeginnerPath() {
  return (
    <>
      <Seo
        title="7-Day Beginner Path · Simple Meditation World"
        description="A gentle 7-day path. One doorway each day. No pressure. No belief system. Just direct experience."
        path="/beginner-path"
      />
      <section className="section-ivory" id="path" style={{ background: "#FBF5EA", paddingTop: 100 }}>
        <div className="container">
          <div className="section-head">
            <span className="eyebrow">Start gently</span>
            <h1>Start with <em>7 simple doorways</em></h1>
            <p>If 112 techniques feel overwhelming, begin with a gentle 7-day path. One doorway each day. No pressure. No belief system. Just direct experience.</p>
          </div>
          <div className="day-row">
            {beginnerDays.map((d) => (
              <Link key={d.d} className="day-card" to={`/beginner-path/day/${d.d}`}>
                <div className="day-label">DAY</div>
                <div className="day-num">{String(d.d).padStart(2, "0")}</div>
                <div className="day-title">{d.title}</div>
                <div className="day-fam">{familyMeta[d.family].label}</div>
              </Link>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 50 }}>
            <Link className="btn btn-primary" to="/beginner-path/day/1">Begin Day 1 {Icon.arrowSm()}</Link>
          </div>
        </div>
      </section>
    </>
  );
}
